export class TerminologyTransformer {
  static transform(obj) {
    return {
      id: obj.id,
      key: obj.attributes.key,
      value: obj.attributes.value,
      type: obj.attributes.type
    };
  }
}



// WEBPACK FOOTER //
// ./src/helpers/terminologies/teminology.transformer.js